var exports = {
  "X7": "UserProfileBadges.module__containerModal___XzdCUW",
  "j4": "UserProfileBadges.module__containerModalMobile___XzdCUW",
  "pP": "UserProfileBadges.module__containerModalDesktop___XzdCUW",
  "Ub": "UserProfileBadges.module__pending___XzdCUW",
  "RS": "UserProfileBadges.module__containerPopout___XzdCUW",
  "Qk": "UserProfileBadges.module__badgeMobile___XzdCUW",
  "EJ": "UserProfileBadges.module__badgeDesktop___XzdCUW",
  "SI": "UserProfileBadges.module__captionBadge___XzdCUW",
  "Kd": "UserProfileBadges.module__captionBadgeMobile___XzdCUW",
  "eA": "UserProfileBadges.module__captionBadgeDesktop___XzdCUW",
  "nf": "UserProfileBadges.module__link___XzdCUW",
  "$J": "UserProfileBadges.module__linkButton___XzdCUW",
  "zH": "UserProfileBadges.module__details___XzdCUW",
  "i5": "UserProfileBadges.module__detailsArt___XzdCUW",
  "x2": "UserProfileBadges.module__detailsTitle___XzdCUW",
  "L4": "UserProfileBadges.module__detailsLine___XzdCUW",
};

module.exports = exports;
